import { useCallback, useEffect, useRef } from 'react';

import { useOnTyping } from './chat_hooks';

// useChatOnChange will fire off debounced typing started and typing stopped events when the
// composer content has changed.
export default function useChatOnChange() {
  // Store the callbacks on a ref so that we don't have to re-create the callback..
  // Plate doesn't handle re-creating plugins, so we need to ensure that the plugin
  // using this onChange has a static callback.

  const { onStartTyping, onStopTyping } = useOnTyping();
  const useTypingRef = useRef({ onStartTyping, onStopTyping });

  useEffect(() => {
    useTypingRef.current = { onStartTyping, onStopTyping };
  }, [onStartTyping, onStopTyping]);

  const previousChildrenRef = useRef(null);

  return useCallback(children => {
    if (children && children.length && previousChildrenRef.current !== children) {
      const { onStartTyping, onStopTyping } = useTypingRef.current;
      onStartTyping();
      onStopTyping();
      previousChildrenRef.current = children;
    }
  }, []);
}
